<div
  (click)="open(item)"
  [ngClass]="{ 'api-email': item.contactEmail }"
  class="tCol clickCol pad"
  id="RowSelect1_{{ item.id }}"
  >
  @if (!item.contactEmail && !item.roleItem) {
    <div class="initials desktop">{{ getInitials(item) }}</div>
  }
  {{ item.roleItem ? item.roleName : item.email || item.contactEmail }}
</div>
